(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('TransactionSummaryCtrl', TransactionSummaryCtrl);

  // @ngInject
  function TransactionSummaryCtrl(storeKeys, filters, DateUtil, ConsumerChart, StandardReports, TransactionReports,
                                  Callout, SectionConfig, CalloutLabelService) {
    var vm = this;
    var detailLevel = filters.pathParams.detailLevel;

    vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};

    vm.transactionColorSwatch = StandardReports.getColorSwatches();
    
    var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});

    var sessions = SectionConfig.sessions;
    var orders = SectionConfig.orders;
    var conversion = SectionConfig.conversion;

    vm.apiParams = { detailLevel: detailLevel, queryParams: queryFilters };

    vm.sessionSection = Callout.labelValueConfig(sessions);

    vm.orderSection = Callout.labelValueConfig(orders);

    vm.conversionSection = Callout.liftConfig(conversion);

    vm.sessionChartData = function (rawData) {
      return rawData;
    };

    vm.orderChartData = function (rawData) {
      return rawData;
    };

    vm.conversionChartData = function (rawData) {
      return rawData;
    };
  }
  })();
